import * as React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { GlassCard } from '../../../components/glassmorphism/GlassmorphismStyles';

function CategorySkeleton({ highlighted = false }: { highlighted?: boolean }) {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: { xs: 140, sm: 180 },
        borderRadius: '32px',
        p: { xs: 2, sm: 3 },
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        background: 'rgba(255,255,255,0.08)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
      }}
    >
      {/* icon */}
      <Skeleton variant='circular' width={64} height={64} animation='wave' />

      {/* text */}
      <Box sx={{ flex: 1 }}>
        <Skeleton
          variant='text'
          width='70%'
          height={28}
          animation='wave'
          sx={{ transform: 'none' }}
        />
        <Skeleton
          variant='text'
          width='50%'
          height={24}
          animation='wave'
          sx={{ transform: 'none' }}
        />
      </Box>
    </Box>
  );
}

export default function SelectCategoriesSkeleton() {
  return (
    <GlassCard
      sx={{
        width: '100%',
        maxWidth: '956px',
        mx: 'auto',
        p: { xs: 3, sm: 5 },
        borderRadius: '40px',
      }}
    >
      <Stack spacing={4}>
        {/* TITLE */}
        <Box textAlign='center'>
          <Skeleton
            variant='text'
            width={320}
            height={48}
            animation='wave'
            sx={{ mx: 'auto', transform: 'none' }}
          />
          <Skeleton
            variant='text'
            width='70%'
            height={24}
            animation='wave'
            sx={{ mx: 'auto', transform: 'none' }}
          />
        </Box>

        {/* GRID */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
            },
            gap: 3,
          }}
        >
          <CategorySkeleton />
          <CategorySkeleton highlighted />
          <CategorySkeleton />
          <CategorySkeleton />
        </Box>

        {/* STEPPER */}
        <Box>
          <Stack spacing={1}>
            <Skeleton
              variant='rounded'
              height={6}
              sx={{
                borderRadius: '999px',
                width: '100%',
              }}
            />

            <Stack direction='row' justifyContent='space-between'>
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} width={60} height={20} />
              ))}
            </Stack>
          </Stack>
        </Box>

        {/* BUTTON */}
        <Box display='flex' justifyContent='flex-end'>
          <Skeleton
            variant='rounded'
            width={180}
            height={44}
            sx={{ borderRadius: '999px' }}
          />
        </Box>
      </Stack>
    </GlassCard>
  );
}
